import { render, staticRenderFns } from "./ModelParamList.vue?vue&type=template&id=d246e9bc"
import script from "./ModelParamList.vue?vue&type=script&lang=js"
export * from "./ModelParamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports